import "./_powers-of-appointment-row.scss";
import React, {useEffect, useState} from "react";
import {Button, UnderlinedHeader,} from "src/components";
import {Member} from "../../model/EstateFlowchartTypes";
import RadioGroupField from "../FormContent/RadioGroupField/RadioGroupField";
import * as PoaType from "./PoaType";
import * as PoaTransferType from "./PoaTransferType";
import DropdownField from "../FormContent/DropdownField/DropdownField";
import TextAreaField from "../FormContent/TextAreaField/TextAreaField";
import {PowerOfAppointment} from "./PowerOfAppointment";
import {createFamilyMemberDropdownItems} from "../../utils/DefUtils";

type PowerOfAppointmentRowProps = {
    powerOfAppointmentForm: PowerOfAppointment;
    onChangePOA: (updatedPOA: PowerOfAppointment) => void;
    onDeletePOA: Function;
    index: number;
    familyMembers: Member[];
    trustIndex: number;
};

export default function PowerOfAppointmentRow({
                                                  powerOfAppointmentForm,
                                                  onChangePOA,
                                                  onDeletePOA,
                                                  index,
                                                  familyMembers,
                                                  trustIndex,
                                              }: Readonly<PowerOfAppointmentRowProps>) {

    const [powerOfAppointment, setPowerOfAppointment] = useState<PowerOfAppointment>(powerOfAppointmentForm);

    useEffect(() => {
        setPowerOfAppointment(powerOfAppointmentForm)
    }, [powerOfAppointmentForm]);

    return (
            <div className={"power-of-appointment-row"}>
                <UnderlinedHeader
                    className={"power-of-appointment-row-header"}
                    leftAlignedContent={
                        <p className="power-of-appointment-label">POWER OF APPOINTMENT {index + 1}</p>
                    }
                    rightAlignedContent={
                        <Button
                            data-testid={"delete-poa-button-" + (index + 1)}
                            className={"delete-button"}
                            ariaLabel="delete"
                            onClick={() => onDeletePOA()}
                            icon="left"
                            iconName="delete"
                            kind="borderless"
                        > </Button>
                    }
                />

                <RadioGroupField id={`poa-type-${trustIndex}-${index}`}
                                 label="Type"
                                 values={Object.keys(PoaType.PoaType)}
                                 selectedValue={powerOfAppointment.type.valueOf()}
                                 onChange={(selection) => {
                                     const updatedPOA = {
                                         ...powerOfAppointment,
                                         type: PoaType.fromValue(selection)
                                     }
                                     setPowerOfAppointment(updatedPOA);
                                     onChangePOA(updatedPOA);
                                 }}/>

                <RadioGroupField id={`poa-transfer-type-${trustIndex}-${index}`}
                                 label="Transfer Type"
                                 values={Object.keys(PoaTransferType.TransferType)}
                                 selectedValue={powerOfAppointment.transferType.valueOf()}
                                 onChange={(selection) => {
                                     const updatedPOA = {
                                         ...powerOfAppointment,
                                         transferType: PoaTransferType.fromValue(selection)
                                     }
                                     setPowerOfAppointment(updatedPOA);
                                     onChangePOA(updatedPOA);
                                 }}/>

                <DropdownField value={powerOfAppointment.powerHolder ?? ""}
                               label="Power Holder"
                               items={createFamilyMemberDropdownItems(familyMembers, powerOfAppointment.powerHolder)}
                               onChange={(value) => {
                                   const updatedPOA = {
                                       ...powerOfAppointment,
                                       powerHolder: value,
                                   }
                                   setPowerOfAppointment(updatedPOA);
                                   onChangePOA(updatedPOA);
                               }}
                               required={true}
                               dataTestId={"power-holder-dropdown-" + (index + 1)}/>

                <TextAreaField input={powerOfAppointment.permissibleAppointees}
                               label={"Permissible Appointees"}
                               onChange={(value) => {
                                   const updatedPOA = {
                                       ...powerOfAppointment,
                                       permissibleAppointees: value
                                   };
                                   setPowerOfAppointment(updatedPOA);
                                   onChangePOA(updatedPOA);
                               }}
                               subText={"Eg: Descendents, charity, sometimes spouse of descendents/ " +
                                   "(three most common in that order)"}
                               dataTestId={"permissible-appointees-field-" + (index + 1)}/>

                <TextAreaField input={powerOfAppointment.additionalDetails}
                               label={"Additional Details"}
                               onChange={(value) => {
                                   const updatedPOA = {
                                       ...powerOfAppointment,
                                       additionalDetails: value
                                   };
                                   setPowerOfAppointment(updatedPOA);
                                   onChangePOA(updatedPOA);
                               }}
                               subText={"Eg: at #age get % amount"}
                               dataTestId={"additional-details-field-" + (index + 1)}/>
            </div>
    );
}
